import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

/**
 * Обёртка Sonner под shadcn/ui: тема из next-themes + классы в тонах design tokens приложения.
 * Вызовы: `import { toast } from "sonner"` (как в документации shadcn).
 */
const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          title: "group-[.toast]:font-semibold group-[.toast]:text-foreground",
          description: "group-[.toast]:text-muted-foreground group-[.toast]:text-sm",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success:
            "group-[.toaster]:border-l-4 group-[.toaster]:border-l-primary group-[.toaster]:bg-background",
          error:
            "group-[.toaster]:border-l-4 group-[.toaster]:border-l-destructive group-[.toaster]:bg-background",
          warning:
            "group-[.toaster]:border-l-4 group-[.toaster]:border-l-amber-500/80 group-[.toaster]:bg-background dark:group-[.toaster]:border-l-amber-400/70",
          info:
            "group-[.toaster]:border-l-4 group-[.toaster]:border-l-muted-foreground/50 group-[.toaster]:bg-background",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
